import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBeijingsubwayComponent } from './simple-icons-beijingsubway.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBeijingsubwayComponent ],
    exports:      [ SimpleIconsBeijingsubwayComponent ],
    bootstrap:    []
})
export class SimpleIconsBeijingsubwayModule {}
